import React, { useMemo } from 'react';
import { useRecoilValue } from 'recoil';
import PropTypes from 'prop-types';

import { FlexBoxColumn } from '@ecp/common/src/layouts/flex/styled';
import { Spacing } from '@ecp/common/src/layouts/Spacing';
import { TextBox } from '@ecp/common/src/text/TextBox';
import Button from '@ecp/common/src/components/button/bo/Button';
import { PriceUtils } from '@ecp/common/src/utils/price/PriceUtils';

import { isManagerValue } from '@bo-recoil/common/user/atom';
import { ContentTitle } from '@bo-components/common/styled';
import Form from '@bo-components/common/form/Form';
import FormField from '@bo-components/common/form/FormField';

const useYN = (yn) => (yn === 'Y' ? '사용' : '미사용');

const MemberInfo = ({ siteBasicInfo, applyExceptPayMeanList }) => {
  const priceUtils = new PriceUtils();
  const isManager = useRecoilValue(isManagerValue) && !location.pathname.includes('minor');
  const handleMoveTo = (toUrl) => {
    window.open(toUrl);
  };
  const payMeanNameList = useMemo(
    () => applyExceptPayMeanList.map(({ payMeanName }) => payMeanName).join(', '),
    [applyExceptPayMeanList]
  );
  const themeText = useMemo(() => {
    switch (siteBasicInfo.theme) {
      case 'default':
        return '웰스토리몰';

      default:
        return siteBasicInfo.theme;
    }
  }, [siteBasicInfo.theme]);

  const priceFormat = useMemo(
    () => (priceUtils.isUsePriceFormat(siteBasicInfo.priceFormat) ? siteBasicInfo.priceFormat : '미사용'),
    [siteBasicInfo.priceFormat]
  );

  const priceFormatPerKrw = useMemo(() => {
    const priceFormat = siteBasicInfo.priceFormat;

    if (priceUtils.isUsePriceFormat(priceFormat)) {
      return `1${priceFormat} = ${siteBasicInfo.priceFormatPerKrw}원`;
    } else {
      return '미사용';
    }
  }, [siteBasicInfo.priceFormat, siteBasicInfo.priceFormatPerKrw]);

  return (
    <FlexBoxColumn width={'100%'} align-items={'flex-start'}>
      <ContentTitle type={'secondary'} width={'100%'}>
        기타환경
      </ContentTitle>
      <Spacing bottom={'8px'} />
      <Form>
        <FormField label={'적립금'}>
          <TextBox>{useYN(siteBasicInfo.reserveUseYn)}</TextBox>
        </FormField>
        <FormField label={'쿠폰'}>
          <TextBox>{useYN(siteBasicInfo.couponUseYn)}</TextBox>
          <Spacing margin={'auto'} />
          <Button type={'Third'} move width={'114px'} onClick={() => handleMoveTo('/promo/promotion-management')}>
            프로모션관리
          </Button>
        </FormField>
        <FormField label={'회원등급'}>
          <TextBox>{useYN(siteBasicInfo.memberGradeUseYn)}</TextBox>
          <Spacing margin={'auto'} />
          {isManager && (
            <Button type={'Third'} move width={'114px'} onClick={() => handleMoveTo('/member/grade')}>
              회원등급관리
            </Button>
          )}
        </FormField>
        <FormField label={'쿠폰 메뉴 사용'}>
          <TextBox>{useYN(siteBasicInfo.couponMenuExpsYn)}</TextBox>
        </FormField>
        <FormField label={'1:1문의'}>
          <TextBox>{useYN(siteBasicInfo.otoQuestUseYn)}</TextBox>
          <Spacing margin={'auto'} />
          {isManager && (
            <Button
              type={'Third'}
              move
              width={'104px'}
              onClick={() => handleMoveTo('/customer-service/counseling/management')}
            >
              1:1문의관리
            </Button>
          )}
        </FormField>
        <FormField label={'포인트'}>
          <TextBox>{useYN(siteBasicInfo.pointUseYn)}</TextBox>
          <Spacing margin={'auto'} />
          {isManager && (
            <Button type={'Third'} move width={'104px'} onClick={() => handleMoveTo('/point/point-group-management')}>
              포인트관리
            </Button>
          )}
        </FormField>
        <FormField label={'장바구니'}>
          <TextBox>{useYN(siteBasicInfo.cartUseYn)}</TextBox>
        </FormField>
        <FormField label={'복지포인트 명칭'}>
          <TextBox>{siteBasicInfo.pntExpsNm}</TextBox>
        </FormField>
        <FormField label={'가격노출'}>
          <TextBox>{useYN(siteBasicInfo.priceExpsUseYn)}</TextBox>
        </FormField>
        <FormField label={'인기검색어 컬렉션명'}>
          <TextBox>
            {siteBasicInfo.bestSkwdCollectionName == '' ? '미사용' : siteBasicInfo.bestSkwdCollectionName}
          </TextBox>
        </FormField>
        <FormField label={'주문확인 자동 예외'}>
          <TextBox>{useYN(siteBasicInfo.orderConfirmAutoExceptYn)}</TextBox>
        </FormField>
        <FormField label={'대량주문배송 메뉴 노출'}>
          <TextBox>{useYN(siteBasicInfo.bulkOrdMenuUseYn)}</TextBox>
        </FormField>
        <FormField label={'결제 제외 수단'}>
          <TextBox>{payMeanNameList}</TextBox>
        </FormField>
        <FormField label={'상품 카드 장바구니'}>
          <TextBox>{useYN(siteBasicInfo.goodCardCartBtnUseYn)}</TextBox>
        </FormField>
        <FormField label={'디자인 테마'} full>
          <TextBox>{themeText}</TextBox>
        </FormField>
        <FormField label={'금액 노출 단위'} full>
          <TextBox>{priceFormat}</TextBox>
        </FormField>
        <FormField label={'금액 환산 비율'} full>
          <TextBox>{priceFormatPerKrw}</TextBox>
        </FormField>
      </Form>
    </FlexBoxColumn>
  );
};

export default MemberInfo;

MemberInfo.propTypes = {
  siteBasicInfo: PropTypes.object,
  applyExceptPayMeanList: PropTypes.arrayOf(PropTypes.object),
};
